import {TranslationsManager} from "../utils/localisationManager";

export function doStyleProductsListing() {
    $('.product').each(function (index, element) {
        $(element).find('.price-standard').prependTo($(element).find('.prices'));
        $(element).find('.prices').insertAfter($(element).find('.name'));

        doStyleProductFlags();

        $(element).find('a.image').wrap('<div class="image-wrapper"/>')
        const widgets = $(element).find('.widget-parameter-wrapper')

        if(widgets.length) {
            const parameter = widgets.find('.widget-parameter-value')
            const parametersArray = Array.from(parameter)
            const productLink = $(element).find('a.image').attr('href')

            if(parametersArray.length > 6) {
                const split = splitArrayFirst(parametersArray, productLink)

                $(widgets).find('.widget-parameter-list').children().remove();
                $(widgets).find('.widget-parameter-list').append(split)
            }

            widgets.appendTo($(element).find('.image-wrapper'));
        }
    })
}
function splitArrayFirst(productSizesElements, link) {
    const middleOfArrayIndex = Math.floor(productSizesElements.length / 2);

    const hasElementBeforeLeftBound = !!productSizesElements[middleOfArrayIndex - 3];
    const hasElementAfterRightBound = !!productSizesElements[middleOfArrayIndex + 3];

    const elementsWithoutLeftBound = productSizesElements.slice(0, middleOfArrayIndex - 2).map(elem => $(elem).text().trim())
    const elementsWithoutRightBound = productSizesElements.slice(middleOfArrayIndex + 3, productSizesElements.length).map(elem => $(elem).text().trim())

    if (hasElementBeforeLeftBound) {
        const tmpSizeElem = $(`<li class="widget-parameter-value"><a href="${link}" title="Velikost: FROM">${TranslationsManager.doGetStringByLang("SIZE_FROM")} ${elementsWithoutLeftBound[0]}</a></li>`)
        productSizesElements = [tmpSizeElem, ...productSizesElements.filter(elem => !elementsWithoutLeftBound.includes($(elem).text().trim()))]

    }
    if (hasElementAfterRightBound) {
        const tmpSizeElem = $(`<li class="widget-parameter-value"><a href="${link}" title="Velikost: TO">${TranslationsManager.doGetStringByLang("SIZE_TO")} ${elementsWithoutRightBound[elementsWithoutRightBound.length -1]}</a></li>`)
        productSizesElements = [...productSizesElements.filter(elem => !elementsWithoutRightBound.includes($(elem).text().trim())), tmpSizeElem]

    }

    return productSizesElements;
}

export function doStyleProductFlags() {
    $('.product .flag').each(function (index, element) {
        const backgroundColor = $(element).css('background-color');

        $(`<span class="after"></span>`).appendTo(element);
        $(element).find('.after').css('border-left-color', backgroundColor);
    })
}
